import { render, staticRenderFns } from "./UmbOnboardingInfo.vue?vue&type=template&id=980a998e"
import script from "./UmbOnboardingInfo.vue?vue&type=script&lang=ts"
export * from "./UmbOnboardingInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports